/* unplugin-vue-components disabled */import script from "./proj-kpi-editor-form.vue?vue&type=script&setup=true&lang=js"
export * from "./proj-kpi-editor-form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__